/* @generated */
import * as React from "react";
import { useFindContentIcon } from "./hooks.esm.js";
const FileIcon = ({
  extension,
  size = "small",
  ...props
}) => {
  const Icon = useFindContentIcon({ extension, size });
  return /* @__PURE__ */ React.createElement(Icon, { ...props });
};
FileIcon.displayName = "ContentFileIcon";
export {
  FileIcon
};
